import store from '../store/store';

export default function isCalendarPeekShown() {
    return store.moduleCommand === 'Open_ItemPeek' || store.moduleCommand == 'Open_ItemCancelPeek';
}
